import {
  deleteLocalPreference,
  getLocalPreference,
  setLocalPreference,
} from "../offline/database.js";

export const fictionalDrillIds = [
  "OFFLINE_OPEN",
  "MEETING_POINT",
  "VAULT_UNLOCK",
  "CARD_PREVIEW",
  "BACKUP_RESTORE",
  "KNOWN_GOOD_RECOVERY",
] as const;
export type FictionalDrillId = (typeof fictionalDrillIds)[number];

export interface DrillCompletionMetadata {
  readonly completedIds: readonly FictionalDrillId[];
  readonly updatedAt: string;
}

const drillMetadataKey = "readiness.drill-completion.v1";

export async function loadDrillCompletion(): Promise<DrillCompletionMetadata> {
  return (
    ((await getLocalPreference(drillMetadataKey)) as DrillCompletionMetadata | undefined) ?? {
      completedIds: [],
      updatedAt: "",
    }
  );
}

export async function toggleDrillCompletion(
  id: FictionalDrillId,
): Promise<DrillCompletionMetadata> {
  const current = await loadDrillCompletion();
  const completedIds = current.completedIds.includes(id)
    ? current.completedIds.filter((value) => value !== id)
    : [...current.completedIds, id];
  const next = { completedIds, updatedAt: new Date().toISOString() };
  await setLocalPreference(drillMetadataKey, next);
  return next;
}

export async function eraseDrillCompletion(): Promise<void> {
  await deleteLocalPreference(drillMetadataKey);
}
